import { render, staticRenderFns } from "./actInfoSetting.vue?vue&type=template&id=265e412e&scoped=true"
import script from "./actInfoSetting.vue?vue&type=script&lang=js"
export * from "./actInfoSetting.vue?vue&type=script&lang=js"
import style0 from "./actInfoSetting.vue?vue&type=style&index=0&id=265e412e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e412e",
  null
  
)

export default component.exports